import { createTranslator, type TranslateFn } from '@mangovoice/mango-ui'

/**
 * Formats a human-readable list of assigned assets (extensions, devices) for
 * the "cannot remove user" dialog. Returns phrases like:
 *   - "1 assigned extension"
 *   - "3 assigned devices"
 *   - "2 assigned extensions and 1 assigned device"
 * Empty counts are omitted. Returns an empty string when both counts are 0.
 *
 * When a `t` translator is provided, keys are taken from
 * `users.formatAssignedAssets.*` with i18next-style pluralization.
 */
export function formatAssignedAssets(
  extensionCount: number,
  deviceCount: number,
  t?: TranslateFn,
): string {
  const tr = createTranslator(t)

  const parts: string[] = []
  if (extensionCount > 0) {
    parts.push(
      tr(
        'users.formatAssignedAssets.extension',
        `${extensionCount} assigned extension${extensionCount === 1 ? '' : 's'}`,
        { count: extensionCount },
      ),
    )
  }
  if (deviceCount > 0) {
    parts.push(
      tr(
        'users.formatAssignedAssets.device',
        `${deviceCount} assigned device${deviceCount === 1 ? '' : 's'}`,
        { count: deviceCount },
      ),
    )
  }
  return parts.join(tr('users.formatAssignedAssets.and', ' and '))
}
